const data: any = [{"key":"cancel","copy":"Cancel"},{"key":"verify","copy":"Verify"},{"key":"reveal-card-numbers","copy":"Reveal {{> virtual-card:core/variables }} Numbers"}];
export default data